export default {
  waiting: 'Kilimall will review your store application within 5 business days. You can also contact sellercenter@kilimall.com for updates.',
  txt: 'Check the status of store application    ',
  continueCreateStore: 'Continue to create a store',
  // from
  phone: 'Enter the phone number to check the status of the application    ',
  code: 'Verification code    ',
  query: 'Submit    ',
  ruleMsgPhone: 'Please input the phone number    ',
  ruleMsgCode: 'Please enter verification code    ',
  // table
  date: 'Application date',
  name: 'Store Name',
  type: 'Store Type',
  status: 'Status',
  detail: 'View details',
  check: 'View',
  TypeB: 'Type B',
  TypeC: 'Type C',
  pendingReview: 'Pending review',
  reviewPassed: 'Approved',
  reviewRefused: 'Rejected',
  back: 'Back',
  goingBackUpdateInfo: 'Going back to the previous step will not save or update the information entered in this step.',
  stayOnThisStep: 'Stay on this step',
  continueToPreviousStep: 'Continue to go back to the previous step',
}
